/* global angular, moment */
(function () {
  'use strict';
  angular.module('vcfinance.cart')
    .component('carteditor', {
      restrict: 'E',
      bindings: {
        clientid: '<?',
        showtaxdetails: '@?',
        diagnoses: '<?',
        timeframe: '<?',
        test: '<?'
      },
      template: `
        <form>
        <div ng-show="vm.diagnoses">
          <h4>Diagnosen für Rechnung</h4>
          <diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.parentsave()"></diagnosesedit>
          <!--<textarea ng-model="vm.cart.invoicediagnoses" class="form-control" required ng-blur="vm.setDiagnoses(vm.cart.invoicediagnoses)"></textarea>-->
        </div>
        <div ng-show="vm.timeframe">
          <h4>Leistungszeitraum</h4>
          <input type="text" ng-model="vm.cart.timeframe" class="form-control" required ng-blur="vm.setTimeframe(vm.cart.timeframe)">
        </div>
        <h4>Suche nach Dienstleistungen</h4>
        <privcatsearch privcat="" privcatref="" hideaddoption="true" onselectcb="vm.addItem(privcat, privcatref)"></privcatsearch>

        <h4>Leistungsgruppen</h4>
        <privcatgroupchooser onselectcb="vm.addItem(privcat, privcatref)"></privcatgroupchooser>


        <h4>Warenkorb</h4>
        <table class="table">
        <colgroup>
          <col width="15%">
          <col width="63%">
          <col width="12%">
          <col width="10%">
        </colgroup>
        <tr class="table-header">
          <th>Stk</th>
          <th>Bezeichnung</div>
          <th class="text-right">Brutto</th>
          <th class="text-right">Steuer</th>
        </tr>
        
    
        <tr ng-repeat="item in vm.cart.items">
          <td  style="vertical-align: middle">
          <span class="input-group">
            <input type="number" ng-if="item.repeatable === true" ng-model="item.quantity" min="1"
                   class="form-control"
                   ng-change="vm.updateItem(item)">
            <input type="number" ng-if="item.repeatable === false" ng-model="item.quantity" min="1" max="1"
                   class="form-control"
                   readonly
                   ng-change="vm.updateItem(item)">
                   <span class="input-group-btn">
                        <span class="btn btn-danger" uib-tooltip="Position entfernen"
                              ng-click="vm.removeItem(item)">
                            <i class="fa fa-remove"></i></span>
                        </span>
                   </span>
          </td>
          <td  style="vertical-align: middle">{{item.name}}
            <br ng-show="item.details && item.details.length >0">{{item.details}} </td>
          <td class="text-right"  style="vertical-align: middle">&euro;&nbsp;{{(item.price * item.quantity) | number: 2}}</td>
          <td class="text-right"  style="vertical-align: middle">{{item.tax}}%</td>
        </tr>

        <tr style="font-weight: bold; border-top: solid 1px black;">
          <td></td>
          <td class="text-right">Netto:</td>
          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.netto| number: 2}}</td>
          <td class="text-right"></td>
        </tr>
        <tr style="font-weight: bold; border-bottom: solid 1px black;">
          <td></td>
          <td class="text-right">Steuer gesamt:</td>
          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.taxdiscounted| number: 2}}</td>
          <td class="text-right"></td>
        </tr>
        <tr style="font-weight: bold;" ng-show="vm.showtaxdetails" ng-repeat="(key, val) in vm.cart.inv.discounttaxsum">
          <td></td>
          <td class="text-right">Steuer {{key}}%:</td>
          <td class="text-right">&euro;&nbsp;{{val| number: 2}}</td>
          <td class="text-right"></td>
        </tr>
                <tr style="font-weight: bold; border-bottom: double 1px black;">
          <td></td>
          <td class="text-right">Brutto:</td>
          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.totalbefore| number: 2}}</td>
          <td class="text-right"></td>
        </tr>
        <tr style="font-weight: bold; border-bottom: solid 1px black; vertical-align: middle">
          <td></td>
          <td class="text-right" style="vertical-align: middle">Rabatt:</td>
          <!--<td class="text-right">&euro;&nbsp;-{{vm.cart.inv.discount| number: 2}}</td>-->
          <td class="text-right" style="white-space: nowrap;">&euro;&nbsp;&ndash;&nbsp;<input type="quantity" step="0.01" min="0"  max="{{vm.cart.inv.total}}"
                                                     class="form-control"
                                                     style="width: 75%; display: inline; text-align: right"
                                                     ng-blur="vm.setDiscount(vm.cart.inv.discount)"
                                                     ng-model="vm.cart.inv.discount">
          </td>
          <td class="text-right"></td>
        </tr>
        <tr style="font-weight: bold; border-bottom: double 1px black;">
          <td></td>
          <td class="text-right">Gesamt:</td>
          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.total| number: 2}}</td>
          <td class="text-right"></td>
        </tr>
        </table>
        </form>
        
        <div class="spacer-top spacer-bottom" ng-show="vm.cart.items.length > 0">
            <div class="alert alert-info">
                <div class="row">
                <div class="col-xs-12"><h4>Wechselgeld</h4></div>
                <div class="col-xs-6">
                    <label>Erhalten</label>
                    <input type="quantity" min="0" step="0.01" ng-model="vm.cashin"
                           ng-model-options="{ debounce: 1000 }"
                           style="text-align: right" class="form-control"
                           ng-change="vm.calcChange(vm.cashin, vm.cart.inv.total)"
                           >
                </div>
                <div class="col-xs-6">
                    <label>Retour</label>
                    <input type="quantity" min="0" step="0.01" ng-model="vm.return"
                           class="form-control" readonly style="text-align: right">
                </div>
                </div>
            </div>
        </div>
        
        <div class="spacer-top spacer-bottom" ng-show="vm.cart.items.length > 0">
            <a class="btn btn-info" href="{{vm.previewlink}}" target="_blank">
                      <i class="fa fa-eye"></i> Rechnungsvorschau
            </a>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Cart', 'Rlog', 'vertxEventBusService', 'ConsultHelper', 'PrintHelper', 'ClientHelper',
        function ($log, Cart, Rlog, vertxEventBusService, ConsultHelper, PrintHelper, ClientHelper) {
          let vm = this;
          vm.updateItem = updateItem;
          vm.addItem = addItem;
          vm.removeItem = removeItem;
          vm.setDiscount = setDiscount;
          vm.setDiagnoses = setDiagnoses;
          vm.setTimeframe = setTimeframe;
          vm.calcChange = calcChange;
          vm.parentsave = parentsave;

          $log.debug('Carteditor called: ', vm.clientid, vm.diagnoses);


          vm.$onInit = function () {
            if ((angular.isUndefined(vm.cart) || !vm.cart.hasOwnProperty('_id'))
              && angular.isDefined(vm.cartid)) {
              Cart.$find(vm.cartid).$then(function (cart) {
                vm.cart = cart;
              }, function (err) {
                $log.error('cart not found, id: ', vm.cartid);
                Rlog.error('cart', 'carteditor', 'cart not found', {_id: vm.cartid});
              });
            }
            if (angular.isDefined(vm.clientid)) {
              getCart();
              getClient();
            }
          };

          // vm.clientid might be late propagating, get exams on first change
          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue) && changes.clientid.currentValue.length > 0) {
              vm.clientid = changes.clientid.currentValue;
              /*              if (angular.isDefined(vm.clientid)) {
                              getCart();
                            }*/
              getCart();
              getClient();
            }
            $log.debug('changes: ', changes);
            if (angular.isDefined(changes.diagnoses) && angular.isDefined(changes.diagnoses.currentValue)) {
              vm.initialdiagnoses = changes.diagnoses.currentValue;
            }


            if (angular.isDefined(changes.timeframe) && angular.isDefined(changes.timeframe.currentValue)) {
              vm.timeframe = changes.timeframe.currentValue;
              Cart.setTimeframe(vm.clientid, vm.timeframe);
            }
          };


          function calcChange(received, total) {
            let quantity = received - total;
            let factor = Math.pow(10, 2);
            vm.return = Math.round(quantity * factor) / factor;
          }

          function getCart() {
            Cart.getCart(vm.clientid).then(function (res) {
                $log.debug('getCart res: ', res);
                vm.cart = res.data;
                if (angular.isDefined(vm.initialdiagnoses)) {
                  vm.cart.invoicediagnoses = vm.initialdiagnoses;
                }

                if (angular.isDefined(vm.timeframe)) {
                  vm.cart.timeframe = vm.timeframe;
                }
                vm.previewlink = PrintHelper.cartPreviewUrl(vm.cart._id);
              },
              function (err) {
                $log.error('getCart failed for patientid: ', vm.clientid);
              });
          }

          function getClient() {
            ClientHelper.find('patient', vm.clientid).$then(function (client) {
              vm.client = client;
              if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
                vm.client.deleteddiagnoses = [];
                vm.client.$save();
                $log.debug('initalised deleteddiagnoses to empty array');
              }
              setDiagnoses(vm.client.diagnoses);
            }, function (err) {
              vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
              Rlog.error('client', 'carteditor', 'client.$find() failed', {id: vm.clientid});
            });
          }


          function updateItem(item) {
            Cart.updateItem(vm.clientid, item).then(function (res) {
              },
              function (err) {
                $log.error('updateItem failed for clientid/patientid, item: ', vm.clientid, item._id, item.name);
              });
          }

          function removeItem(item) {
            Cart.removeItem(vm.clientid, item).then(function (res) {
              },
              function (err) {
                $log.error('removeItem failed for clientid/patientid, item: ', vm.clientid, item._id, item.name);
              });
          }

          function addItem(privcat, privcatref) {
            $log.debug('addItem privcat: ', privcat, privcatref);
            Cart.addItem(vm.clientid, privcat).then(function (res) {
              },
              function (err) {
                $log.error('addItem failed for clientid/patientid, item: ', vm.clientid, privcat._id, privcat.name);
              });
          }

          function setDiscount(discount) {
            Cart.setDiscount(vm.clientid, discount).then(function (res) {
              },
              function (err) {
                $log.error('setDiscount failed for clientid/patientid, item: ', vm.clientid);
              });
          }


          function setTimeframe(timeframe) {
            Cart.setDiscount(vm.clientid, timeframe).then(function (res) {
              },
              function (err) {
                $log.error('setTimeframe failed for clientid/patientid, item: ', vm.clientid);
              });
          }

          function setDiagnoses(diagnoses) {
            $log.debug('setdiagnoses called with: ', diagnoses);
            let invoicediagnoses = [];
            diagnoses.forEach((d) => {
                $log.debug('d: ', d, !d.hasOwnProperty('active') || d.active === true, !d.hasOwnProperty('hideInInvoices')||d.hideInInvoices === false);

              if ((!d.hasOwnProperty('active') || d.active === true) && (!d.hasOwnProperty('hideInInvoice') || d.hideInInvoice === false)) {
                $log.debug('d selected: ', d);
                invoicediagnoses.push(d.key);
              }
            });

            let flatdiagnoses = invoicediagnoses.join(', ');

            $log.debug('Updated flatdiagnoses: ', flatdiagnoses);
            Cart.setDiagnoses(vm.clientid, flatdiagnoses).then(function (res) {
              },
              function (err) {
                $log.error('setDiagnoses failed for clientid/patientid, item: ', vm.clientid);
              });
          }


          function parentsave() {
            $log.debug('**** carteditor parentsave called:', vm.client.diagnoses);
            setDiagnoses(vm.client.diagnoses);
            if (!angular.equals(vm.client, vm.lastclient)) {
              vm.client.flatdiagnoses = vm.client.diagnoses.map(function (diag) {
                return diag.key;
              });
              $log.debug('**** patientheader saving child :', vm.client.diagnoses, vm.client.flatdiagnoses);
              vm.lastclient = angular.copy(vm.client);
              if (vm.client.$hasPendingActions) {
                vm.client.$cancel();
              }
              setDiagnoses(vm.client.diagnoses);
              vm.client.$save().$then(function () {
              }, function (err) {
                $log.error('debug/error: client save failed!', err);
                Rlog.error('client', 'clienteditor', 'client.$save() failed', {id: vm.client._id});
              });
            }
          }

          vertxEventBusService.on('carts.update', function (message) {
            let messages = message.split(':');
            vm.cart = getCart();
            $log.debug('(carteditor) refreshed cart');
            // only refresh exam if change was NOT triggered by this browser tab
            /*            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.exam._id === messages[0]) {
                          vm.cart = getCart();
                          $log.debug('(carteditor) refreshed cart');
                        }
                        else {
                          $log.debug(' (carteditor) ignored cart change');
                        }*/
          });


          vertxEventBusService.on('patients.update', function (message) {
            $log.debug('debug: Patient update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
              vm.client.$refresh().$then(function () {
                setDiagnoses(vm.client.diagnoses);
                $log.debug('debug: carteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              }, function (error) {
                $log.debug('debug: carteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              });
            }
          });


        }] // controller
    }); // component

// klammerfriedhof
}());